import { Theme } from '@material-ui/core';

const styles = (theme: Theme) => ({
  root: {},
  infoBox: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.common.coral}`,
    backgroundColor: theme.palette.common.backgroundDark,
    padding: '18px 40px',
    maxWidth: 630,
    margin: '30px auto 0',
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    '&.width-full': {
      maxWidth: '100%',
      margin: '30px 0 0 0',
    },
  },
  infoBoxText: {},
  errorIconContainer: {
    backgroundColor: theme.palette.common.coral,
    width: 63,
    height: 63,
    borderRadius: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  errorIcon: {},
});

export default styles;
